import * as Yup from "yup";

export const changePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string().required("Old password is required"),
  newPassword: Yup.string().required("New password is required"),
});

export const updateProfileSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phoneNumber: Yup.string().required("Phone number is required"),
  address: Yup.string().required("Address is required"),
  district: Yup.string().required("District is required"),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  gender: Yup.string().oneOf(["MALE", "FEMALE"]).required("Select gender"),
  isActive: Yup.boolean(),
});
